import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import ShadowBox from '../chrome/ShadowBox';
import Text from '../chrome/Text';
import { Image } from '../index';
import { getAssetSet } from '../../app/context/utils';
import { useCdnImage } from '../../app/context/config';

const containerBaseStyles = () => css`
  display: flex;
  align-items: stretch;
  height: 100%;
`;

const Container = styled('div')(containerBaseStyles);

const imageWrapperBaseStyles = () => css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12px;
`;

const ImageWrapper = styled('div')(imageWrapperBaseStyles);

const textContainerBaseStyles = ({ theme }) => css`
  color: #3f2021;
  display: flex;
  align-items: center;
  min-height: 46px;
  margin-left: ${theme.spacings.byte};
`;

const textContainerErrorStyles = ({ theme, variant }) =>
  variant === 'error' &&
  css`
    color: ${theme.colors.r500};
  `;

const StyledImage = styled(Image)`
  width: ${({ theme }) => theme.spacings.mega};
  height: ${({ theme }) => theme.spacings.mega};
`;

const ShadowBoxWrapper = styled(ShadowBox)`
  background-color: ${({ theme }) => theme.colors.g200};
  box-shadow: none;
  padding: ${({ theme }) => theme.spacings.kilo} ${({ theme }) => theme.spacings.giga};
`;

const TextContainer = styled('div')(textContainerBaseStyles, textContainerErrorStyles);

const AlertBanner = ({ text, variant }) => {
  const getAssetSetUrl = (filename) => getAssetSet(useCdnImage, filename);
  return (
    <ShadowBoxWrapper rounded>
      <Container data-testid='alert-banner'>
        <ImageWrapper>
          <StyledImage src={getAssetSetUrl('iconNewLock')} />
        </ImageWrapper>
        <TextContainer variant={variant}>
          <Text size='mega' noMargin>
            {text}
          </Text>
        </TextContainer>
      </Container>
    </ShadowBoxWrapper>
  );
};

AlertBanner.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string,
};

AlertBanner.defaultProps = {
  variant: 'success',
};

export default AlertBanner;
